import { ReactComponent as IconTelegram } from "@images/icons/icon-telegram.svg";
import { ReactComponent as IconEmail } from "@images/icons/icon-email.svg";
import { ReactComponent as IconPhone } from "@images/icons/icon-phone.svg";

import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_TELEGRAM } from "./constants";

export const contactLinks = [
  {
    label: "SkeyTix_Team",
    href: CONTACT_TELEGRAM,
    target: "_blank",
    icon: <IconTelegram />
  },
  {
    label: CONTACT_EMAIL,
    href: `mailto:${CONTACT_EMAIL}`,
    target: "_blank",
    icon: <IconEmail />
  },
  {
    label: "660 537 007",
    href: `tel:${CONTACT_PHONE}`,
    target: "_blank",
    icon: <IconPhone />
  }
];
